import { render, staticRenderFns } from "./Diagnoses.vue?vue&type=template&id=70e9d62a&"
import script from "./Diagnoses.vue?vue&type=script&lang=js&"
export * from "./Diagnoses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports